import { appConfig } from '@/shared/config/app-config'

/**
 * Marker cookie for cross-subdomain session detection.
 *
 * Set on the parent domain so the landing can detect an active session
 * in the web app without accessing localStorage.
 *
 * Contains no sensitive data — just a boolean flag.
 * Tokens stay in localStorage (no CSRF risk).
 */

const COOKIE_NAME = appConfig.sessionCookie.name
const COOKIE_DOMAIN = appConfig.sessionCookie.domain

/**
 * Set marker cookie with maxAge matching refresh token lifetime.
 */
export function setMarkerCookie(refreshExpiresAt: number): void {
  const now = Math.floor(Date.now() / 1000)
  const maxAge = Math.max(0, refreshExpiresAt - now)

  document.cookie = [
    `${COOKIE_NAME}=true`,
    `domain=${COOKIE_DOMAIN}`,
    `path=/`,
    `max-age=${maxAge}`,
    `secure`,
    `samesite=lax`,
  ].join('; ')
}

/**
 * Remove marker cookie (logout, 401, session invalid).
 */
export function clearMarkerCookie(): void {
  document.cookie = [
    `${COOKIE_NAME}=`,
    `domain=${COOKIE_DOMAIN}`,
    `path=/`,
    `max-age=0`,
    `secure`,
    `samesite=lax`,
  ].join('; ')
}
